import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Route to title mapping
const routeTitleMap: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/equipment': 'Equipment',
  '/inspections': 'Inspections',
  '/inspections/checklists': 'Checklists',
  '/maintenance': 'Maintenance',
  '/inventory': 'Inventory',
  '/reports': 'Reports',
  '/users': 'Users',
  '/tenants': 'Tenants',
  '/departments': 'Departments',
  '/my-permissions': 'My Permissions',
  '/settings': 'Settings',
  '/admin/permission-requests': 'Permission Requests',
  '/examples/permissions': 'Permission Examples',
  '/examples/shadcn': 'Shadcn Demo',
}

const APP_NAME = 'Al Maysarah IM'

/**
 * Custom hook to update document.title based on the current route
 * @param customTitle - Optional custom title to override the default route-based title
 */
export const usePageTitle = (customTitle?: string) => {
  const location = useLocation()

  useEffect(() => {
    let title = customTitle

    if (!title) {
      // Try to get title from route map
      title = routeTitleMap[location.pathname]

      // If not found, generate from pathname
      if (!title) {
        const segments = location.pathname.split('/').filter(Boolean)
        if (segments.length > 0) {
          const lastSegment = segments[segments.length - 1]
          title = lastSegment
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
        }
      }
    }

    // Update document title
    document.title = title ? `${title} | ${APP_NAME}` : APP_NAME
  }, [location.pathname, customTitle])
}
